import styles from './Form.module.css';
import {useNavigate} from "react-router-dom";


export default function Form() {

    const navigate = useNavigate();


    return (
        <div>
            <div className={styles.root}>
                <div className="wrapper" style={{padding: 0}}>
                    <table style={{width: '100%'}}>
                        <tbody>
                        <tr>
                            <td style={{width: '50%'}}></td>
                            <td>
                                <span style={{cursor: 'pointer'}} onClick={() => navigate("/datenschutz")}>Datenschutz</span>
                            </td>
                            <td>•</td>
                            <td>
                                <span style={{cursor: 'pointer'}} onClick={() => navigate("/impressum")}>Impressum</span>
                            </td>
                            <td>•</td>
                            <td style={{whiteSpace: 'nowrap'}}>
                                <span style={{cursor: 'pointer'}} onClick={() => navigate("/agb")}>Allgemeine Geschäftsbedingungen</span>
                            </td>
                            <td style={{width: '50%'}}></td>





                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <br/>
            <br/>
        </div>
    )
}
